import { defineTranslateKeys } from 'lib/tolgee'

export const translations = defineTranslateKeys({
  dropdownActionRemove: {
    key: 'DocumentsUploadListItem-dropdown-action-remove',
    defaultValue: 'Remover',
  },
  fileStatusUploading: {
    key: 'DocumentsUploadListItem-file-status-uploading',
    defaultValue: 'Enviando',
  },
  fileStatusProcessing: {
    key: 'DocumentsUploadListItem-file-status-processing',
    defaultValue: 'Processando',
  },
  fileStatusProcessed: {
    key: 'DocumentsUploadListItem-file-status-processed',
    defaultValue: 'Pronto',
  },
})
